import { EmptyObject, ValueOf } from "type-fest";

import { WorkbenchTab, WorkbenchTabGroup } from "../../workbench/state";

import { ContextWorkbenchFileId } from "./contextWorkbenchFile";

type AnyObject = Record<string, unknown>;

export type ContextWorkbenchEditorTab = ContextWorkbenchEditorTab.FileEditor;

/**
 * A tab in a context workbench editor viewport. A tab is an item in the
 * viewport and exists in a tab group.
 */
export namespace ContextWorkbenchEditorTab {
  export const Type = {
    FileEditor: "fileEditor",
  } as const;

  export type Type = ValueOf<typeof Type>;

  /**
   * A generic base type for all context workbench tabs. A unique type key
   * must be provided. Optionally specify properties.
   */
  type _Base<
    TType extends Type,
    TProperties extends AnyObject = EmptyObject,
  > = WorkbenchTab & { type: TType } & TProperties;

  /**
   * A tab that represents a file.
   */
  export type FileEditor = _Base<
    "fileEditor",
    { fileId: ContextWorkbenchFileId }
  >;

  // TODO(CUR-981): add FileDiffEditor
}

export type ContextWorkbenchEditorTabGroups =
  WorkbenchTabGroup<ContextWorkbenchEditorTab>[];
